export default __webpack_public_path__ + "static/media/4.bcf65bd3.png";